import { Globe } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { useNavigate, useLocation } from "react-router-dom";
import { localeNames, localeFlags, type Locale } from "@/i18n/translations";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const locales: Locale[] = ["en", "th", "es", "zh", "ar", "fr", "pt", "ja", "ko", "de", "hi", "vi", "id", "tr", "ru", "it", "pl", "nl", "sv", "fil"];

export const LanguageCurrencySelector = () => {
  const { locale, setLocale } = useI18n();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLocaleChange = (newLocale: Locale) => {
    setLocale(newLocale);

    // Strip current locale prefix from path
    const currentPath = location.pathname;
    const localePattern = /^\/(en|es|zh|ar|fr|pt|ja|ko|de|th|hi|vi|id|tr|ru|it|pl|nl|sv|fil)(\/|$)/;
    const strippedPath = currentPath.replace(localePattern, "/");
    const cleanPath = strippedPath === "" ? "/" : strippedPath;

    // Navigate to new locale-prefixed path
    if (newLocale === "en") {
      navigate(cleanPath);
    } else {
      navigate(`/${newLocale}${cleanPath === "/" ? "" : cleanPath}`);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-1.5 rounded-lg border border-border bg-secondary px-2.5 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm font-medium text-muted-foreground transition-all hover:border-primary/40 hover:text-primary hover:shadow-[0_0_12px_hsl(185_100%_50%/0.2)]">
          <Globe className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
          <span className="hidden sm:inline">{localeFlags[locale]} {localeNames[locale]}</span>
          <span className="sm:hidden">{localeFlags[locale]}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {locales.map((l) => (
          <DropdownMenuItem
            key={l}
            onClick={() => handleLocaleChange(l)}
            className={locale === l ? "bg-primary/10 text-primary" : ""}
          >
            <span className="mr-2">{localeFlags[l]}</span>
            {localeNames[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
